import React from 'react';

import { default as MaterialButton } from '@mui/material/Button';
import { alpha } from '@mui/material/styles';

import SafeLink from '../../../blocks/Header/components/SafeLink/SafeLink';
import styled from '../../../styled';
import { colorsPalette } from '../../../theme';

const Button = ({ text = '', link = '#', isPrimary = true, className = '', ...rest }) => {
  return (
    <StyledButton
      variant="contained"
      className={className}
      data-testid={rest['data-testid']}
      isPrimary={isPrimary}
    >
      <SafeLink to={link}>{text}</SafeLink>
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled(MaterialButton, {
  shouldForwardProp: (prop) => prop !== 'isPrimary' && prop !== 'additionalStyles',
})`
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  border-radius: 999em;
  box-shadow: none;
  border: 3px solid ${colorsPalette.primary};
  background: ${({ isPrimary }) =>
    isPrimary ? colorsPalette.transparent : colorsPalette.whiteSecondary};
  padding: 0;
  transition: 0.3s ease all;

  & a {
    text-decoration: none;
    padding: 16px 32px;
    color: ${colorsPalette.white};
  }

  &:hover {
    box-shadow: 0px 3px 6px ${colorsPalette.black};
    background: ${({ isPrimary, theme }) =>
      isPrimary ? theme.palette.primary.main : colorsPalette.whiteSecondary};
    margin-bottom: 1px;
    margin-top: -1px;
    color: ${alpha(colorsPalette.blackPure, 0.87)};
  }

  & a:hover {
    color: ${alpha(colorsPalette.blackPure, 0.87)};
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: 16px;
    padding: 0;
  }
`;
